import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import ScrollToTop from '../components/ScrollToTop';
import BASE_URL from '../BASEURL';

const Release = () => {
  const [releases, setReleases] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    document.title = "Releases - Gujarat State APP Association 2025";
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.content = "Stay updated with the latest releases, announcements, and publications from the Gujarat State Assistant Public Prosecutors Association (GSAPPPA) 2025.";
    }
    
    let canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.href = "https://gsappa.kevalontechnology.in/releases";
    } else {
      canonical = document.createElement('link');
      canonical.rel = 'canonical';
      canonical.href = 'https://gsappa.kevalontechnology.in/releases';
      document.head.appendChild(canonical);
    }
    
    // Update OG tags
    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) ogTitle.content = "Releases - Gujarat State APP Association 2025";
    
    const ogDescription = document.querySelector('meta[property="og:description"]');
    if (ogDescription) ogDescription.content = "Stay updated with the latest releases, announcements, and publications from the Gujarat State Assistant Public Prosecutors Association (GSAPPPA) 2025.";
    
    const ogUrl = document.querySelector('meta[property="og:url"]');
    if (ogUrl) ogUrl.content = "https://gsappa.kevalontechnology.in/releases";
    
    // Update Twitter tags
    const twitterTitle = document.querySelector('meta[property="twitter:title"]');
    if (twitterTitle) twitterTitle.content = "Releases - Gujarat State APP Association 2025";
    
    const twitterDescription = document.querySelector('meta[property="twitter:description"]');
    if (twitterDescription) twitterDescription.content = "Stay updated with the latest releases, announcements, and publications from the Gujarat State Assistant Public Prosecutors Association (GSAPPPA) 2025.";
    
    const twitterUrl = document.querySelector('meta[property="twitter:url"]');
    if (twitterUrl) twitterUrl.content = "https://gsappa.kevalontechnology.in/releases";

    const fetchReleases = async () => {
      try {
        const response = await fetch(`${BASE_URL}/api/releases`);
        if (!response.ok) {
          throw new Error('Failed to fetch releases');
        }
        const data = await response.json();
        setReleases(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchReleases();
  }, []);

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: "easeOut"
      }
    }
  };

  if (loading) {
    return (
      <div className="bg-gradient-to-b from-gray-50 to-white min-h-screen text-gray-800 flex items-center justify-center">
        <div className="flex flex-col items-center">
          <div className="animate-spin rounded-full h-32 w-32 border-b-4 border-[#D4A017] mb-4"></div>
          <div className="text-2xl">Loading Release Notes...</div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <>
        <div className="min-h-screen flex items-center justify-center">
          <div className="text-center">
            <h2 className="text-2xl font-bold text-gray-800 mb-4">Error Loading Releases</h2>
            <p className="text-gray-600">{error}</p>
          </div>
        </div>
        <ScrollToTop />
      </>
    );
  }

  return (
    <>
     <section className="relative bg-gradient-to-r from-[#0B0B0B] via-[#1A1A1A] to-[#0B0B0B] text-white py-40 md:py-48 text-center overflow-hidden">
                    <div className="absolute inset-0 bg-black/55" />
                    <div className="relative z-10 max-w-5xl mx-auto px-6">
                      <motion.h1 initial={{ y: 60, opacity: 0 }} animate={{ y: 0, opacity: 1 }} transition={{ duration: 1.1 }} className="text-5xl md:text-7xl font-extrabold text-[#D4A017] tracking-tight">
Notification               </motion.h1>
                      <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.5, duration: 1 }} className="mt-6 text-xl md:text-2xl text-gray-200 font-medium">
                        THE GUJARAT STATE ASSISTANT PUBLIC PROSECUTORS ASSOCIATION – 2025
                      </motion.p>
                      <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.8, duration: 1 }} className="mt-4 text-lg text-gray-300 max-w-3xl mx-auto">
Latest announcements, publications, and updates from our association    
                      </motion.p>
                    </div>
                  </section>
      <motion.div
        initial="hidden"
        animate="visible"
        variants={containerVariants}
        className="min-h-screen bg-gray-50 py-12"
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          

          {releases.length === 0 ? (
            <motion.div variants={itemVariants} className="text-center">
              <p className="text-gray-600">No releases available at the moment.</p>
            </motion.div>
          ) : (
            <motion.div
              variants={containerVariants}
              className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6"
            >
              {releases.map((release) => (
                <motion.div
                  key={release._id}
                  variants={itemVariants}
                  className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300"
                >
                  <div className="aspect-w-1 aspect-h-1">
                    {release.Release_photo.toLowerCase().endsWith('.pdf') ? (
                      <a href={`${BASE_URL}${release.Release_photo}`} target="_blank" rel="noopener noreferrer" className="flex items-center justify-center w-full h-48 bg-gray-100 hover:bg-gray-200 transition-colors cursor-pointer">
                        <div className="text-center">
                          <svg className="w-16 h-16 mx-auto mb-2 text-red-500" fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H7z" clipRule="evenodd" />
                          </svg>
                          <p className="text-sm font-medium text-gray-700">View PDF</p>
                        </div>
                      </a>
                    ) : (
                      <a href={`${BASE_URL}${release.Release_photo}`} target="_blank" rel="noopener noreferrer">
                        <img
                          src={release.Release_photo}
                          alt={release.Release_name}
                          className="w-full h-48 object-cover cursor-pointer"
                          onError={(e) => {
                            e.target.src = '/placeholder-image.jpg'; // Fallback image
                          }}
                        />
                      </a>
                    )}
                  </div>
                  <div className="p-4">
                    <h3 className="text-lg font-semibold text-gray-900 mb-2">{release.Release_name}</h3>
                  </div>
                </motion.div>
              ))}
            </motion.div>
          )}
        </div>
      </motion.div>
      <ScrollToTop />
    </>
  );
};

export default Release;
